import React from 'react';
import styled from 'styled-components';
import messageStripe from '@components/MessageStripe';

const MessageStripe = styled(messageStripe)`
  a,
  p {
    text-align: center;
  }
`;

type Props = React.PropsWithChildren<{ appearance: 'main' | 'urgent' }>;

const THEMES = {
  main: {
    bg: '#D9E8E7',
    color: '#0C2A28',
  },
  urgent: {
    bg: '#CC206A',
    color: '#FFFFFF',
  },
} as const;

export const PromotionBanner = (props: Props) => {
  const { appearance = 'main' } = props;
  const { bg, color } = THEMES[appearance];

  return (
    <MessageStripe bg={bg} color={color}>
      {props.children}
    </MessageStripe>
  );
};
